<template src="./groups.html"></template>
<script>
import Axios from "axios";
import $ from "jquery";
import { required, sameAs } from "vuelidate/lib/validators";
import Endpoints from "@/config/ApiEndpoints.js";

export default {
  components: {},
  filters: {
    date: function (data) {
      if (data == "" || data == null) {
        return "N/A";
      }
      var reqdString = "";
      for (let i = 0; i < 10; i++) {
        reqdString += data[i];
      }
      var arr = reqdString.split("-");
      reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
      return reqdString;
    },
  },
  data() {
    return {
      ShowAddPopup: false,
      ShowGroupVehicleListModel: false,
      ShowGroupQRModel: false,
      group_title: "",
      popupHeading: "Add Group",
      Groups: [],
      GroupData: {},
      Vehicles: [],
      group_excel_data: [],
      editID: "",
      SearchLoader: false,
      QRCodeEndpoint: Endpoints.QR.Generate + "?content=",

      Users: [],

      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      filter: {
        currentPage: 1,
        totalPages: 0,
      },
      filters: {
        name: {
          value: "",
          keys: ["title"],
        },
      },
    };
  },
  validations: {
    ChangePassword: {
      new_password: { required },
      confirm_new_password: {
        required,
        sameAsPassword: sameAs("new_password"),
      },
    },
  },
  mounted() {
    this.GetGroups();
  },
  methods: {
    ShowGroupQRCode(Group) {
      this.GroupData = Group;
      this.ShowGroupQRModel = true;
    },
    getGroupQRCode(group) {
      let data = { id: group.id, type: "fleet_group" };
      var qrurl = this.QRCodeEndpoint + btoa(JSON.stringify(data));
      return qrurl;
    },
    ShowGroupVehicleList(GroupId) {
      this.ShowGroupVehicleListModel = true;
      /* this.$swal({
        title: "Fetching Vehicle List...",
        text: "Please wait...",
        imageUrl: require("@/assets/images/LoadingTwo.gif"),
        showConfirmButton: false,
        allowOutsideClick: false,
      }); */
      Axios.post(Endpoints.Groups.VehicleList, {
        token: localStorage.getItem("token"),
        fleet_group_id: GroupId,
      }).then((Response) => {
        if (Response?.data?.success == true) {
          this.Vehicles = Response.data.records;
          // this.$swal.close();
        }
      });
    },
    AddUser() {
      this.editID = "";
      this.group_title = "";
      this.popupHeading = "Add Group";
      this.ShowAddPopup = true;
    },
    EditGroup(id) {
      this.editID = id;
      this.group_title = "";
      var obj = {
        token: localStorage.getItem("token"),
        id: id,
      };
      Axios.post(Endpoints.Groups.Get, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.popupHeading = "Edit Group";
          this.group_title = Response.data.record.title;
          this.ShowAddPopup = true;
        }
      });
    },
    SaveGroup() {
      if (this.group_title == "") {
        this.$swal.fire("Please enter group title", "", "error").then(() => {});
      } else {
        $("#save_btn").html("Processing...");
        var obj = {
          token: localStorage.getItem("token"),
          title: this.group_title,
          id: this.editID,
        };
        Axios.post(Endpoints.Groups.Create, obj).then((Response) => {
          $("#save_btn").html("Save");
          if (Response?.data?.success) {
            this.group_title = "";
            this.ShowAddPopup = false;
            this.GetGroups();
            this.$swal
              .fire(Response?.data?.message || "Something went wrong", "", "success")
              .then(() => {});
          } else {
            this.$swal
              .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
              .then(() => {});
          }
        });
      }
    },
    GetGroups() {
      var obj = {
        token: localStorage.getItem("token"),
      };
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.Groups = Response.data.records;
          this.group_excel_data = [];
          if (this.Groups.length > 0) {
            this.Groups.forEach((element) => {
              var obj = {};
              obj["Title"] = element.title;
              obj["Created"] = element.date_display;
              this.group_excel_data.push(obj);
            });
          }
        }
      });
    },

    DeleteGroup(id) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: "Deleting...",
            text: "Please wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Groups.Delete, {
            token: localStorage.getItem("token"),
            id: id,
          }).then((Response) => {
            if (Response?.data?.success === true) {
              this.$swal.close();
              this.GetGroups();
              this.$swal
                .fire("Group Deleted Successfully", "", "success")
                .then(() => {});
            } else {
              this.$swal
                .fire(Response?.data?.message || "Something went wrong", "", "error")
                .then(() => {});
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.UsersBody td {
  padding-left: 15px !important;
}
.UsersBody .btn-primary {
  border: 1px solid transparent !important;
}
.table thead th,
.table th,
.table td {
  border: 0 !important;
}
@media (min-width: 1280px) and (max-width: 1680px) {
  .actionBTN {
    width: 25%;
  }
}
@media (min-width: 780px) and (max-width: 1370px) {
  .actionBTN {
    min-width: 190px;
  }
}
</style>
